import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'

const accessToken = 'pk.eyJ1Ijoid2VicGFyZWJyaXNlIiwiYSI6ImNrdTVnZHU2OTFvYW0ycG8xeHduNWpvbncifQ.mw_fjiXRcHeM7GY_MVUX4Q'
const mapContainer = document.querySelector('.container_search_map')
if (mapContainer) {
  const mapWrap = mapContainer.querySelector('.map')
  const listWrap = mapContainer.querySelector('.list')
  const formSearchGarages = document.querySelector('.searchGarageHeader')
  const currentLocationButton = formSearchGarages.querySelector('.current-location')

  mapboxgl.accessToken = accessToken

  let garages = []

  const map = new mapboxgl.Map({
    container: mapWrap,
    style: 'mapbox://styles/mapbox/streets-v11',
    center: [1.8883335, 46.603354],
    zoom: 5
  })

  const geolocate = new mapboxgl.GeolocateControl()
  map.addControl(geolocate)

  currentLocationButton.onclick = (e) => {
    e.preventDefault()
    geolocate.trigger()
  }

  // Une fois que mapbox à chargé
  map.on('load', () => {

    let form = new FormData()
    form.append('action', 'search-garages')
    form.append('s', '')

    fetch(window.config.adminajax, {
      method: 'POST',
      body: form
    })
      .then(response => response.json())
      .then((response) => {
        if (response.success) {
          updateGarages(response.data || [])
        }
      })
  })

  const orderByDistance = (point) => {
    if (!point) {
      point = map.getCenter()
    }
    garages = garages.map(garage => {
      return {
        ...garage,
        distance: point.distanceTo(garage.marker.getLngLat())
      }
    })

    garages.sort(function (a, b) {
      return a.distance - b.distance
    })

    return garages;

  }

  const updateListGarages = () => {
    listWrap.innerHTML = ''
    garages.map(garage => {
      listWrap.innerHTML += garage.itemHtml
    })

    let garagesitems = listWrap.querySelectorAll('.garage-item')
    if (garagesitems.length) {
      Array.from(garagesitems).map(item => {
        item.addEventListener('click', () => {
          map.flyTo({
            center: [item.dataset.lng, item.dataset.lat],
            zoom: 12
          })
        })
      })
    }
  }

  // On met à jour les garages (markes + liste)
  const updateGarages = (items) => {
    garages = []
    items.map(garage => {
      const marker = new mapboxgl.Marker({
        color: '#f37021'
      })
        .setLngLat([garage.adresse.longitude, garage.adresse.latitude])
        .setPopup(new mapboxgl.Popup().setHTML(garage.itemHtml))
        .addTo(map)

      garages.push({ ...garage, marker })
    })

    map.fitBounds(garages.map(garage => garage.marker.getLngLat()), {
      padding: 100
    })
    orderByDistance()
    updateListGarages()

    // Check if need automatic search
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('current-location')) { // on declanche la geoloc
      geolocate.trigger()
    } else {
      if (urlParams.has('q') && urlParams.has('search')) { // on déclenche la recherche
        const value = urlParams.get('q')
        if (value !== '') {
          searchByValue(value)
        }
      }
    }
  }

  const getClosestGarage = (point) => {
    const firstResult = orderByDistance(point)[0];
    const coordinates = new mapboxgl.LngLat(firstResult.marker['_lngLat']['lng'], firstResult.marker['_lngLat']['lat']);
    return coordinates;
  }

  const searchByValue = (value) => {
    const options = [
      'access_token=' + accessToken,
      'autocomplete=false'
    ]

    fetch('https://api.mapbox.com/geocoding/v5/mapbox.places/' + encodeURI(value) + '.json?' + options.join('&'))
      .then(response => response.json())
      .then(response => {
        const coordinates = new mapboxgl.LngLat(response.features[0].center[0], response.features[0].center[1])
        map.flyTo({
          center: getClosestGarage(coordinates),
          zoom: 12
        })
        orderByDistance(coordinates);
        updateListGarages()
      })
  }

  const searchByLocation = (lng, lat) => {
    const options = [
      'access_token=' + accessToken,
      'autocomplete=false'
    ]

    const lnglat = [lng, lat]
    const searchInput = formSearchGarages.querySelector('[name="q"]')

    orderByDistance(new mapboxgl.LngLat(lng, lat))

    fetch('https://api.mapbox.com/geocoding/v5/mapbox.places/' + lnglat.join(',') + '.json?' + options.join('&'))
      .then(response => response.json())
      .then(response => {
        searchInput.value = response.features[0].place_name
        updateListGarages()
      })
  }

  geolocate.on('geolocate', (data) => {
    searchByLocation(data.coords.longitude, data.coords.latitude)
    mapWrap.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
  })

  // formulaire de recherche
  if (formSearchGarages) {
    formSearchGarages.addEventListener('submit', (e) => {
      e.preventDefault()

      const searchInput = formSearchGarages.querySelector('[name="q"]')
      if (searchInput.value !== '') {
        searchByValue(searchInput.value)
        mapWrap.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/map-search.js